import React from "react";
import { colors } from "@zapalacorp/tokens";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height?: number;
  width?: number;
  color?: string;
}

export function IconTeam(props: SvgComponentProps) {
  const { width = 16, height = 16, color = colors.gray500 } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox="0 0 101 104"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.4 0.800019C16.6 2.80002 12.3333 8.93335 12.3333 16.9334C12.3333 22.8 12.8666 24.1334 16.8666 28.1334C20.8666 32.1334 22.2 32.6667 28.0666 32.6667C36.3333 32.6667 42.2 28.4 44.4666 20.6667C47.9333 8.93335 35.6666 -2.66665 23.4 0.800019ZM36.4666 8.53335C39.1333 11.2 40.3333 13.7334 40.3333 16.6667C40.3333 22.4 34.0666 28.6667 28.3333 28.6667C22.6 28.6667 16.3333 22.4 16.3333 16.6667C16.3333 10.9334 22.6 4.66669 28.3333 4.66669C31.2666 4.66669 33.8 5.86669 36.4666 8.53335Z"
          fill={color}
        />
        <path
          d="M61.8 3.99997C48.6 15.2 58.3333 35.7333 75.2666 32.6666C89.1333 30.1333 93.5333 13.0666 82.8666 4.13331C77.1333 -0.666695 67.5333 -0.666695 61.8 3.99997ZM81.4 9.33331C83 11.3333 84.3333 14.5333 84.3333 16.8C84.3333 22.4 77.9333 28.6666 72.3333 28.6666C69.4 28.6666 66.8666 27.4666 64.2 24.8C58.8666 19.4666 59 13.8666 64.3333 8.39997C67.9333 4.93331 69.1333 4.39997 73.4 5.06664C76.3333 5.59997 79.5333 7.33331 81.4 9.33331Z"
          fill={color}
        />
        <path
          d="M40.4666 36.1333C28.6 46 35 64 50.3333 64C57.2666 64 62.6 60.5333 65.2666 54.2667C69.5333 44.1333 61.5333 32.6667 50.3333 32.6667C46.0666 32.6667 43.5333 33.6 40.4666 36.1333ZM58.7333 41.4667C68.0666 52.1333 52.3333 66.1333 42.3333 56C37.6666 51.4667 37.9333 45.6 43 40.4C46.4666 37.0667 47.8 36.5333 51.4 37.2C53.8 37.6 57 39.4667 58.7333 41.4667Z"
          fill={color}
        />
        <path
          d="M14.8666 36.6667C4.73331 39.6 0.466646 46.6667 0.333313 60.4C0.333313 67.6 0.866646 69.2 3.66665 72.1333C6.59998 75.0667 7.93331 75.4667 16.0666 75.0667C23 74.8 25 74.2667 25 72.6667C25 71.2 22.7333 70.5333 15.6666 70L6.33331 69.3333L5.93331 59.2C5.53331 50 5.93331 48.5333 8.73331 45.2C11.6666 41.8667 13 41.3333 21.8 40.9333C34.0666 40.4 35.8 39.8667 33.8 37.6C32.2 35.6 20.3333 35.0667 14.8666 36.6667Z"
          fill={color}
        />
        <path
          d="M67.8 36.2667C67.4 36.8 67 37.8667 67 38.9333C67 40.1333 69.4 40.6667 75.6667 40.6667C91.1333 40.6667 95.4 44.9333 94.7333 60L94.3333 69.3333L85 70C77.9333 70.5333 75.6667 71.2 75.6667 72.6667C75.6667 74.2667 77.6667 74.8 84.6 75.0667C92.8667 75.4667 93.9333 75.2 97.1333 72C100.467 68.6667 100.6 67.8667 100.067 58.2667C99.4 46.6667 97 41.7333 90.4667 38.4C86.3333 36.2667 69.4 34.6667 67.8 36.2667Z"
          fill={color}
        />
        <path
          d="M29.5333 72.5333C24.4666 77.6 24.3333 77.8667 24.3333 87.4667C24.3333 98.1333 24.8666 99.4667 29.2666 101.867C32.7333 103.6 66.6 103.867 71.4 102.133C76.0666 100.267 78.2 94.1333 77 85.0667C76.2 78.6667 75.2666 76.6667 71 72.4L65.9333 67.3333H50.3333H34.7333L29.5333 72.5333ZM68.4666 76.4C72.0666 80.4 72.4666 81.6 72.0666 89.0667L71.6666 97.3333H50.3333H29L28.6 89.2C28.3333 82.5333 28.7333 80.5333 31.1333 77.4667C35.2666 72.1333 38.2 71.3333 52.0666 71.7333C64.3333 72 64.6 72.1333 68.4666 76.4Z"
          fill={color}
        />
      </svg>

      {/* <svg
        width={width}
        height={height}
        viewBox="0 0 123 125"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35 2.5C44.725 2.5 52.5 10.1704 52.5 19.5C52.5 28.8296 44.725 36.5 35 36.5C25.275 36.5 17.5 28.8296 17.5 19.5C17.5 10.1704 25.275 2.5 35 2.5Z"
          stroke={color}
          stroke-width="10"
        />
        <circle cx="88.5" cy="19.5" r="17" stroke={color} stroke-width="10" />
        <circle cx="61.5" cy="58.5" r="17" stroke={color} stroke-width="10" />
        <path
          d="M51 83.5H72C83.3218 83.5 92.5 92.6782 92.5 104V113C92.5 118.247 88.2467 122.5 83 122.5H40C34.7533 122.5 30.5 118.247 30.5 113V104C30.5 92.6782 39.6782 83.5 51 83.5Z"
          stroke={color}
          stroke-width="10"
        />
        <path
          d="M113.288 85V90H94.2884V85H113.288ZM117.288 81V66C117.288 56.0589 107.73 48.5 97.7884 48.5H82.2318L91.004 87C91.004 85 91.2884 85 94.2884 85V90C91.004 90 91.004 87 91.004 87L82.004 47.5C82.004 46.5 81.8472 43 83.504 43H99.2884C111.991 43 122.288 53.2975 122.288 66V81C122.288 85.9706 118.259 90 113.288 90V85C115.498 85 117.288 83.2091 117.288 81Z"
          stroke-width="10"
          fill={color}
        />
        <path
          d="M9.15896 85V90H28.4946V85H9.15896ZM5.93421 81V73.5V66C5.93421 56.0589 14.816 48.5 24.9327 48.5H40.7641L31.8369 87C31.8369 85 31.5475 85 28.4946 85V90C31.837 90 31.8369 87 31.8369 87L40.996 47.5C40.996 46.5 41.1555 43 39.4694 43H23.4062C10.4793 43 -1.69889e-06 53.2975 -1.73167e-06 66V81C-1.73167e-06 85.9706 4.10061 90 9.15896 90V85C7.55263 84.5 5.93421 83 5.93421 81Z"
          stroke-width="10"
          fill={color}
        />
      </svg> */}
    </SvgWrapper>
  );
}
